export default {
    // récuperer toutes les mandates dans la base de données 
    get_all_mandates(serverParams){
        return axios.get('/operations?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_mandate_by_id(id_mandat){
        return axios.get('/operations/' + id_mandat, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_paiement_by_id(id_mandat){
        return axios.get('/paiement/details/' + id_mandat, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_mandates_setting(serverParams) {
        return axios.post('/operations/par/date', serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    get_all_mandates_own(){
        return axios.get('/mesoperations', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_mandates_by_agency(id){
        return axios.get('/operations/agence/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_mandates_by_guichet(id){
        return axios.get('/operations/guichet/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_mandates_by_user(id){
        return axios.get('/operations/user/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les mandates dans la base de données 
    post_mandates(mandate){
        return axios.post('/operations/transfert/envoi',mandate, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les mandates dans la base de données 
    put_mandates(id_mandat, mandate){
        return axios.put('/operations/'+id_mandat,mandate, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    //récuperer les opérations de toutes les entités par dates
    post_mandates_by_date(data){
        return axios.post('/operations/list?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    //récuperer les opérations de toutes les entités par dates
    post_paiement_by_date(data){
        return axios.post('/paiements/list?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    //récuperer les opérations de l'utilisateur connecté par dates (opérateur)
    post_mandates_by_date_me(data){
        return axios.post('/operations/me?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // récuperer les opérations d'un responsable de son entité
    post_mandatesEntite_by_date_me(data){
        return axios.post('/operations/entite/me?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'une entité precise
    post_mandates_by_entite_by_date_me(data){
        return axios.post('/operations/entite/' + data.entite_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'une agence precise
    post_mandates_by_agence_by_date_me(data){
        return axios.post('/operations/agence/' + data.agency_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'un guichet precise
    post_mandates_by_guichet_by_date_me(data){
        return axios.post('/operations/guichet/' + data.guichet_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'un user precis
    post_mandates_by_user_by_date_me(data){
        return axios.post('/operations/user/' + data.user_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'un user precis
    post_mandates_by_typepiece_by_date_me(data){
        return axios.post('/operations/typepiece/' + data.typedepiece_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // recuperer les opération d'un user precis
    post_mandates_by_typeoperation_by_date_me(data){
        return axios.post('/operations/typeoperation/' + data.typeoperation_id+'?page=' + data.page,data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

    post_tableau_bord_by_date_me_imprim(data){
        return axios.post('/etat/tableaubord/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_tableau_bord_distrib_by_date_me_imprim(data){
        return axios.post('/etat/tableaubord/distrib/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_decaissement_by_date_me_imprim_entite(data){
        return axios.post('etat/decaissements/group/by/entite/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_decaissement_by_date_me_imprim_agence(data){
        return axios.post('etat/decaissements/group/by/agence/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_decaissement_by_date_me_imprim_guichet(data){
        return axios.post('etat/decaissements/group/by/guichet/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_mandates_by_date_me_imprim(data){
        return axios.post('/operation/me/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_mandates_by_entite_imprim(data){
        return axios.post('/operation/group/by/entite/imprimer',data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_mandates_by_agence_imprim(data) {
        return axios.post('/operation/group/by/agence/imprimer', data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    post_mandates_by_guichet_imprim(data) {
        return axios.post('/operation/group/by/guichet/imprimer', data, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    cancel_paiement(mandate){
        return axios.post('/paiement/annuler',mandate, {
            headers: {
                "Content-Type": 'application/json',
                //'Content-Type': 'multipart/form-data',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_paiement(mandate){
        return axios.post('/paiement/etape/2',mandate, {
            headers: {
                "Content-Type": 'application/json',
                //'Content-Type': 'multipart/form-data',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    info_paiement(paiement_file){
        return axios.post('/paiement/etape/1', paiement_file, {
            headers: {
                //"Content-Type": 'application/json',
                'Content-Type': 'multipart/form-data',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_mandates(id){
        return axios.get('/operations/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // impression doc
    impression_operation(id){
        return axios.get('/bordereau/impression/operation/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    impression_statut_paiement(id){
        return axios.get('/report/paiement/status/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id<
    delete_mandates(id){
        return axios.delete('/operations/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    montantttc(data){
        return axios.post('/operations/montantttc',data,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    getInfobyNumTrans(num_transation){
        return axios.post('/operations/transfert/retrait/info', num_transation,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    getInfobyNumTransPlafond(num_transation){
        return axios.post('/operations/autoriser/retrait/infos', num_transation,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    getInfoPaiement(data){
        return axios.post('/paiement/infos', data,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    AnnulerPaiement(data){
        return axios.post('/paiement/retrait/annuler', data,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    getInfobyNumTransAnnulation(num_transation){
        return axios.post('/operations/annulation/infos', num_transation,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    validateRetrait(code_envoie){
        return axios.post('/operations/transfert/retrait', code_envoie,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    validateInfoPaiement(data){
        return axios.post('paiement/retrait', data,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    validateAnnulation(code_envoie){
        return axios.post('/operations/valider/annulation', code_envoie,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    AutoriseAnnulation(code_envoie){
        return axios.post('/operations/autoriser/annulation', code_envoie,{
            headers:{
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    deblocage(data){
        let d={}
        if(data.type_operation=='transfert'){
            d = { num_transaction : data.num_transaction}  
        }else{
            d = { reference_benef: data.reference_benef, code_paiement: data.code_paiement }
        }
        return axios.post('/deblocage/' + data.type_operation + '/infos', d, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
        
    },
    get_all_model() {
        return axios.get('/paiement/model', {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    get_model_by_id(id_model) {
        return axios.get('/paiement/model/' + id_model, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    post_model(model) {
        return axios.post('/paiement/model', model, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    put_model(id_model,model) {
        return axios.put('/paiement/model/'+id_model, model, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    put_deblocage(data) {
        return axios.post('/deblocage/operation/' + data.id, { validite: data.validite, motif: data.motif}, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    get_all_code_paiement(serverParams) {
        return axios.post('/paiement/code/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
}
